/** 已下线品类：历史值统一适配为通用 */
const DEPRECATED_CATEGORY_TO_COMMON = new Set(['派对用品', 'party_supplies']);

export type CaseTypeOption = { label: string; value: string };

/** 适配工作台品类选项：去掉派对用品、杯子→水杯、others→通用 */
export function adaptDefaultCaseTypeOptions(data: CaseTypeOption[] = []): CaseTypeOption[] {
  data.forEach((v) => {
    if (v.label === '派对用品') {
      DEPRECATED_CATEGORY_TO_COMMON.add(v.value);
    }
  });

  const list = data
    .filter((v) => v.label !== '派对用品' && !DEPRECATED_CATEGORY_TO_COMMON.has(v.value))
    .map((v) => (v.label === '杯子' ? { ...v, label: '水杯' } : { ...v }));

  const index = list.findIndex((v) => v.value === 'others');
  if (index >= 0) {
    const otherItem = list[index];
    otherItem.label = '通用';
    otherItem.value = 'common';
    list.splice(index, 1);
    list.unshift(otherItem);
  }

  return list;
}

/** 历史派对用品等下线品类 → 通用 */
export function normalizeUserCategory(category?: string | null): string | undefined {
  if (!category) return category ?? undefined;
  if (DEPRECATED_CATEGORY_TO_COMMON.has(category)) return 'common';
  return category;
}
